import React, { useId } from 'react';
import { Button } from '@dashboard/components/ui/button';

export default function StarterPrompts({ prompts, onUse, onBuild }) {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-1.5">
      <h3 id={headingId} className="text-xs font-semibold leading-4 text-muted-foreground">
        Start with an example
      </h3>
      <ul className="flex flex-col gap-1.5">
        {prompts.map(({ label, prompt }) => (
          <li
            key={label}
            className="flex flex-wrap items-end justify-between gap-x-3 gap-y-1.5 rounded-lg bg-muted px-2.5 py-2"
          >
            <button
              type="button"
              className="min-w-0 flex-1 basis-40 rounded-sm text-left text-[13px] leading-[19px] text-foreground outline-none focus-visible:ring-2 focus-visible:ring-ring"
              onClick={() => onUse(prompt)}
            >
              {label}
            </button>
            <Button
              variant="outline"
              size="xs"
              aria-label={`Build this: ${label}`}
              onClick={() => onBuild(prompt)}
            >
              Build this
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
}
